import { Controller } from '@hotwired/stimulus';
import { pausePlayers } from '../../utils/pausePlayers';
/*
 * Description
 * -------
 *
 * Manages iframe player.
 *
 * Must be used on iframe element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * - watchTimesPath - (required) - API endpoint to save watch time
 *
 * Usage
 * -------
 *
 * <iframe
 *   data-controller="iframe-player"
 *   data-action="blur@window->iframe-player#handleWindowBlur"
 *   data-iframe-player-watch-times-path-value="http://example.com"
 * >
 * </iframe>
 */
export class IframePlayer extends Controller {
    static values = { watchTimesPath: String };
    handleWindowBlur() {
        if (document.activeElement == this.element) {
            fetch(this.watchTimesPathValue, {
                method: 'POST',
            });
            pausePlayers(this.element);
            this.element.dataset.played = 'true';
        }
    }
}
